import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { currentPageState$ } from '../../redux/selectors';
import Logo from '../Logo';

export default function TopHeader() {
    const history = useHistory();
    const [searchValue, setSearchValue] = React.useState('');
    const currentPage = useSelector(currentPageState$);

    const handleChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleClick = (e) => {
        e.preventDefault();
        history.push(`/search/by?value=${searchValue}`);
    }

    if (currentPage !== 'public') {
        return null;
    }

    return (
        <div className="container-fluid row justify-content-lg-between bg-light top-bar">
            <div className="col-lg-auto col-sm-12 logo">
                <Link to="/">
                    <Logo />
                </Link>
            </div>
            <form className="col-lg-auto col-sm-12 d-flex search-bar">
                <input className="form-control" type="text" value={searchValue} onChange={handleChange} />
                <button className="btn btn-outline-primary" onClick={handleClick}>
                    <i className="fa fa-search"></i>
                </button>
            </form>
        </div>
    )
}